import { render } from "./RouteCreate.vue?vue&type=template&id=07c5a41a&scoped=true"
import script from "./RouteCreate.vue?vue&type=script&lang=js"
export * from "./RouteCreate.vue?vue&type=script&lang=js"

import "./RouteCreate.vue?vue&type=style&index=0&id=07c5a41a&scoped=true&lang=css"

import exportComponent from "/Users/patrykslak/Documents/projekty/lauron-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07c5a41a"]])

export default __exports__